import React, { useState, useCallback, useMemo } from 'react';
import ConfirmDialog from '../../../shared/confirmDialog.component';

const useConfirm = (onConfirm, onCancel) => {
  const [isOpen, setOpen] = useState(false);
  const [params, setParams] = useState([]);
  const open = useCallback((...params) => {
    setOpen(true);
    setParams(params);
  }, []);

  const handleConfirm = useCallback(() => {
    onConfirm(...params);
    setOpen(false);
    setParams([]);
  }, [onConfirm, params]);

  const handleCancel = useCallback(() => {
    if (onCancel) {
      onCancel(...params);
    }
    setOpen(false);
    setParams([]);
  }, [onCancel, params]);

  const confirmElement = useMemo(() => function ConfirmDialogWrapper(props) {
    return <ConfirmDialog onCancel={handleCancel} onConfirm={handleConfirm} isVisible={isOpen} {...props}/>;
  }, [handleConfirm, handleCancel, isOpen]);

  return [confirmElement, open];
};

export default useConfirm;
